(function(){
  const topReviews = [
    {name:'Laura Becker · Demo-Profil',title:'Morgens weniger puffy',text:'Meine Morgenroutine ist sonst eher kurz. Velmira passt da gut rein, weil ich nicht noch drei Tools brauche. Besonders angenehm finde ich die Massage am Kiefer – danach wirkt mein Gesicht für mich frischer und weniger aufgedunsen.'},
    {name:'Sophie Wagner · Demo-Profil',title:'Bleibt tatsächlich in meiner Routine',text:'Ich war erst skeptisch, weil viele Beauty-Gadgets nach zwei Wochen in der Schublade landen. Hier mag ich, dass die Anwendung simpel ist. Die Wärme und Vibration machen die Routine überraschend entspannend.'},
    {name:'Nina Hoffmann · Demo-Profil',title:'Abends mein kleiner Face Reset',text:'Ich nutze es meistens abends mit etwas Gesichtsöl. Mein Gesicht fühlt sich danach lockerer an, vor allem rund um Kiefer und Wangen. Genau dieser Self-Care-Moment war mir wichtiger als ein unrealistisches Vorher-Nachher.'},
    {name:'Katharina Müller · Demo-Profil',title:'Frischer nach wenig Schlaf',text:'Nach wenig Schlaf sehe ich morgens schnell puffy aus. Nach der Massage wirkt meine Augen- und Wangenpartie für mich etwas frischer und definierter. Kein Wundergerät – aber ein Ritual, das ich wirklich gern benutze.'},
    {name:'Julia Schneider · Demo-Profil',title:'Angenehmer als mein alter Gua Sha',text:'Ich hatte schon einen normalen Gua-Sha-Stein, habe ihn aber kaum genutzt. Mit Velmira fühlt sich die Routine angenehmer und vollständiger an. Besonders die Wärme macht für mich den Unterschied.'},
    {name:'Anna Fischer · Demo-Profil',title:'Kurze Routine, die sich nicht nach Arbeit anfühlt',text:'Was ich mag: Es dauert nicht ewig und fühlt sich nicht nach zusätzlicher Arbeit an. Ich nutze Velmira morgens oder nach stressigen Tagen, wenn mein Gesicht einfach müder aussieht als ich mich fühle.'}
  ];

  const bottomReviews = [
    {name:'Laura Becker · Demo-Profil',title:'Weniger Puffy-Look am Morgen',text:'Nach der Anwendung wirkt mein Gesicht für mich weniger puffy, besonders morgens. Ich mag, dass es sanft ist und sich in meine normale Skincare einfügt.'},
    {name:'Sophie Wagner · Demo-Profil',title:'Angenehm am Kiefer',text:'Ich nutze es am liebsten am Kiefer. Die Massage fühlt sich entspannend an und ich habe danach das Gefühl, dass meine Konturen etwas frischer wirken.'},
    {name:'Nina Hoffmann · Demo-Profil',title:'Mehr Face Reset als Anti-Aging-Versprechen',text:'Mit etwas Gesichtsöl gleitet das Gerät angenehm über die Haut. Für mich ist es eher ein täglicher Face Reset als irgendein großes Anti-Aging-Versprechen.'},
    {name:'Katharina Müller · Demo-Profil',title:'Praktisch, weil alles in einem Tool ist',text:'Ich war skeptisch wegen der vielen Funktionen. Am Ende ist genau das praktisch: Massage, Wärme, Vibration und Licht in einem Tool statt mehrere Sachen herumliegen zu haben.'},
    {name:'Julia Schneider · Demo-Profil',title:'Mein normaler Gua Sha lag nur herum',text:'Mein alter Gua Sha lag fast nur in der Schublade. Velmira nutze ich öfter, weil die Anwendung sich mehr nach Self-Care und weniger nach einer Pflicht-Routine anfühlt.'},
    {name:'Anna Fischer · Demo-Profil',title:'Entspannend nach stressigen Tagen',text:'Nach stressigen Tagen merke ich Spannung im Kiefer. Die Massage ist für mich ein richtig angenehmer Abschluss am Abend.'},
    {name:'Sarah Klein · Demo-Profil',title:'Gepflegter statt „Wunder-Effekt“',text:'Ich erwarte keine Wunder, aber ich mag den direkten, gepflegteren Look nach der Anwendung. Meine Wangen wirken für mich etwas frischer und ich fühle mich einfach mehr wie ich selbst.'},
    {name:'Marie Neumann · Demo-Profil',title:'Die Wärme macht es angenehmer',text:'Ich mag die Wärme besonders. Zusammen mit der Vibration macht sie die Massage deutlich angenehmer als ein klassischer Stein.'},
    {name:'Leonie Braun · Demo-Profil',title:'Passt gut in meine Morgenroutine',text:'Für mich funktioniert Velmira am besten als kurze Routine am Morgen. Weniger Aufwand als Face Yoga und deutlich angenehmer als noch ein weiteres Serum.'}
  ];

  const replacements = [
    ['Was Frauen an einem Face-Reset-Ritual wichtig ist','Demo-Kundenstimmen zu Velmira'],
    ['Was unsere Kunden sagen!','Demo-Kundenstimmen zu Velmira'],
    ['Was unsere Kunden sagen','Demo-Kundenstimmen zu Velmira'],
    ['Stimmen & Erfahrungen aus unserem Beauty-Research','Beispielbewertungen zur Seitenvorschau – keine verifizierten Käufe'],
    ['basierend auf 436 Bewertungen!','Beispielbewertungen – keine verifizierten Käufe'],
    ['4,8/5','Demo'],
    ['Beauty-Research','Demo'],
    ['Lumessa bereits ausprobiert?','Velmira bereits ausprobiert?'],
    ['Teile deine eigene Erfahrung mit anderen Kunden','Teile deine echte Erfahrung mit anderen Kundinnen.'],
    ['Deine Lumessa-Bewertung','Deine Velmira-Bewertung'],
    ['Neue Lumessa-Bewertung','Neue Velmira-Bewertung']
  ];

  function setIfDifferent(el, value){
    if(el && el.textContent.trim() !== value) el.textContent = value;
  }

  function replaceText(root){
    if(!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while((node = walker.nextNode())){
      let next = node.nodeValue || '';
      replacements.forEach(([from,to]) => { if(next.includes(from)) next = next.split(from).join(to); });
      if(next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function updateTop(){
    const root = document.querySelector('.section-ss_testimonials_38_KNyKhP');
    if(!root) return;
    replaceText(root);
    const heading = Array.from(root.querySelectorAll('h1,h2,h3')).find(el => /Demo-Kundenstimmen|Was unsere Kunden/.test(el.textContent));
    setIfDifferent(heading, 'Demo-Kundenstimmen zu Velmira');
    const note = Array.from(root.querySelectorAll('p,div,span')).find(el => {
      const t = (el.textContent || '').trim();
      return t === 'Stimmen & Erfahrungen aus unserem Beauty-Research' || t === 'Beispielbewertungen zur Seitenvorschau – keine verifizierten Käufe' || t === 'basierend auf 436 Bewertungen!';
    });
    setIfDifferent(note, 'Beispielbewertungen zur Seitenvorschau – keine verifizierten Käufe');
    const cards = root.querySelectorAll('.testimonials-card-ss_testimonials_38_KNyKhP');
    cards.forEach((card,i) => {
      const r = topReviews[i]; if(!r) return;
      setIfDifferent(card.querySelector('.testimonials-card-title-ss_testimonials_38_KNyKhP'), r.title);
      setIfDifferent(card.querySelector('.testimonials-card-text-ss_testimonials_38_KNyKhP'), r.text);
      setIfDifferent(card.querySelector('.testimonials-card-author-ss_testimonials_38_KNyKhP'), r.name);
    });
  }

  function updateBottom(){
    const root = document.querySelector('.lumin-reviews');
    if(!root) return;
    replaceText(root);
    const cards = root.querySelectorAll('.lumin-review-card');
    cards.forEach((card,i) => {
      const r = bottomReviews[i]; if(!r) return;
      setIfDifferent(card.querySelector('.lumin-review-name'), r.name);
      setIfDifferent(card.querySelector('.lumin-review-title'), r.title);
      setIfDifferent(card.querySelector('.lumin-review-text'), r.text);
    });
    const heading = Array.from(root.querySelectorAll('h1,h2,h3,h4')).find(el => /Demo-Kundenstimmen|Was unsere Kunden/.test(el.textContent));
    setIfDifferent(heading, 'Demo-Kundenstimmen zu Velmira');
  }

  function run(){ updateTop(); updateBottom(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true}); else run();
  window.addEventListener('load', run, {once:true});
  let queued = false;
  new MutationObserver(function(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; run(); });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
